import { OpenAPI } from './generated';

const configApiUrl = () => {
  OpenAPI.BASE = import.meta.env.VITE_API_URL;

  if (import.meta.env.DEV) {
    console.log('API URL:', OpenAPI.BASE);
  }
};

configApiUrl();
